import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setErr(null); setLoading(true);
    try {
      const r = await fetch('/api/auth/login', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      if (!r.ok) {
        const body = await r.json().catch(() => ({}));
        throw new Error(body.error ?? `${r.status}`);
      }
      nav('/');
    } catch (e: any) {
      setErr(e.message ?? 'Error');
    } finally { setLoading(false); }
  }

  return (
    <div style={{ display: 'grid', placeItems: 'center', height: '100%', background: '#0f172a', color: '#e2e8f0' }}>
      <form onSubmit={submit} style={{ background: '#1e293b', padding: 32, borderRadius: 12, minWidth: 360, border: '1px solid #334155' }}>
        <h1 style={{ fontSize: 24, marginTop: 0, marginBottom: 8 }}>Geoportales · Goberna</h1>
        <p style={{ color: '#94a3b8', marginBottom: 24, fontSize: 13 }}>Plataforma de mapas dinámicos.</p>
        <label style={{ display: 'block', marginBottom: 12 }}>
          <span style={{ display: 'block', fontSize: 12, color: '#cbd5e1', marginBottom: 4 }}>Email</span>
          <input type="email" value={email} onChange={e => setEmail(e.target.value)} required autoFocus
            style={{ width: '100%', padding: '8px 12px', background: '#0f172a', border: '1px solid #334155', borderRadius: 6, color: '#e2e8f0', boxSizing: 'border-box' }} />
        </label>
        <label style={{ display: 'block', marginBottom: 16 }}>
          <span style={{ display: 'block', fontSize: 12, color: '#cbd5e1', marginBottom: 4 }}>Contraseña</span>
          <input type="password" value={password} onChange={e => setPassword(e.target.value)} required
            style={{ width: '100%', padding: '8px 12px', background: '#0f172a', border: '1px solid #334155', borderRadius: 6, color: '#e2e8f0', boxSizing: 'border-box' }} />
        </label>
        {err && <p style={{ color: '#fca5a5', fontSize: 13, marginBottom: 12 }}>{err}</p>}
        <button type="submit" disabled={loading}
          style={{ width: '100%', padding: 10, background: '#0ea5e9', border: 'none', borderRadius: 6, color: 'white', fontWeight: 600, cursor: 'pointer' }}>
          {loading ? 'Entrando…' : 'Entrar'}
        </button>
      </form>
    </div>
  );
}
